import { useActivitiesStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreActivitiesComponent,
  ProductType,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { ActivityReservation } from "@b2bportal/rbc-activities-api";
import { TripsCard } from "@tenant/trips";
import clsx from "clsx";
import defaultStyles from "./ActivityReservationCard.module.scss";
import { useActivityReservationCard } from "./useActivityReservationCard";
import { TripsReservationStatusPill } from "@/components";

export interface ActivityReservationCardComponentProps
  extends PlatformComponentProps {
  reservation: ActivityReservation;
  selectItinerary: () => void;
}

const COMPONENT_KEY = CoreActivitiesComponent.ActivityReservationCard;

export const ActivityReservationCard = (
  props: ActivityReservationCardComponentProps
) => {
  const styles = useActivitiesStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  const { reservation, selectItinerary, className, children } = props;
  const {
    text: { title, date, confirmationCode, city },
    context: { image, activityStatus, isPastTrip, isCancelled },
  } = useActivityReservationCard(reservation);
  const dateDisplay = isCancelled ? (
    <span style={{ textDecoration: "line-through" }}>{date}</span>
  ) : (
    date
  );

  return (
    <TripsCard
      className={clsx(block, className)}
      title={title}
      onClick={selectItinerary}
      confirmationCode={confirmationCode}
      description={city}
      date={dateDisplay}
      image={image}
      status={
        <TripsReservationStatusPill
          variant={ProductType.ACTIVITIES}
          status={activityStatus}
          isPastTrip={isPastTrip}
        />
      }
    >
      {children}
    </TripsCard>
  );
};
